<template>
  <svg
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="100%"
    height="100%"
    viewBox="0 0 36 36"
    preserveAspectRatio="none"
    id="pipeline_90_rightbottom"
    style="z-index: 1"
  >
    <title>{{ hint }}</title>
    <defs>
      <radialGradient
        fx="-12"
        fy="-12"
        cx="4"
        cy="4"
        r="36"
        gradientUnits="userSpaceOnUse"
        id="rb-KeyGradient"
      >
        <stop style="stop-opacity: 1; stop-color: #3b3838" offset="0.24" />
        <stop style="stop-opacity: 1; stop-color: #dedede" offset="0.69" />
        <stop style="stop-opacity: 1; stop-color: #99a1af " offset="0.88" />
      </radialGradient>
      <radialGradient
        fx="-12"
        fy="-12"
        cx="4"
        cy="4"
        r="36"
        gradientUnits="userSpaceOnUse"
        id="rb-OilGradient"
      >
            
        <!--https://tailwindcss.com/docs/colors gray-->
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="0.24" />
        <stop style="stop-opacity: 1; stop-color: #99a1af" offset="0.69" />
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="0.88" />
      </radialGradient>
      <path
        id="rb-main"
        d="m 0 36  L 0  12 C 8 12 12 8 12 0    L 36 0  C 36 24 24 36 0 36Z"
      />
    </defs>
    <g :visibility="fState[0]">
      <use href="#rb-main" fill="url(#rb-KeyGradient)" />
    </g>
    <g :visibility="fState[1]">
      <use href="#rb-main" fill="url(#rb-OilGradient)" />
    </g>
    <g :visibility="fState[2]">
      <use href="#rb-main" fill="url(#rb-KeyGradient)" />
    </g>
    <g :visibility="fState[3]">
      <use href="#rb-main" fill="url(#rb-KeyGradient)" />
    </g>
    <g :visibility="fState[4]">
      <use href="#rb-main" fill="url(#rb-KeyGradient)" />
    </g>
    <g :visibility="fState[5]">
      <use href="#rb-main" fill="url(#rb-KeyGradient)" />
    </g>
    <g :visibility="fState[10]">
      <use href="#rb-main" fill="url(#rb-KeyGradient)" />
    </g>
  </svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "pipeline_90_rightbottom",
  mixins: [MixinStates],
};
</script>
